import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import actionType from '../../../Redux/Actions/ActionTypes';
import {LoadRegistrastionJournyData} from "../../../Redux/Actions/Actions";
import notify from '../../../Notifications/ToastifyActions';

function SubmitAnswerServices(token,data) {
    return axios.post(`${CURRENT_API_URL}/questionnaire/submitAnswer`,data,{
        headers: {
            'Authorization': token,
        }
    }).then(res => {
            notify.NotifySuccess('Your response saved successfully.')
            return res.data;        
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while saving your response. please try again later.");
        return false;
    });
}


export default SubmitAnswerServices;
